import { AccountBadgeIcon } from './AccountBadgeIcon';

/**
 * author: Andrej Sharapov
 * id 67BA915E-B44A-434E-95D3-9BD94A174164
 * name account-badge
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-badge.svg
 * tags
 * - Account / User 
 */
export const AccountOnlineIcon = AccountBadgeIcon;
export default AccountOnlineIcon